import React, { useContext, useEffect, useState } from 'react';
import { UpsellItems } from '../../components/upsell-items.jsx';
import { CartContext } from '../../context.jsx';
import { filterByItemId, getItemsId } from './helpers';
import { checkHasSubscription } from '../../helpers/checkHasSubscription';
import { SELECTORS } from './constants';

export const UpsellItemsContainer = () => {
  const { dataset: { variantIds }} = document.querySelector(`.${SELECTORS.UPSELL_VARIANT_DATA}`);

  if (!variantIds.length) {
    return null;
  }

  const { cart, addItem, isPending } = useContext(CartContext);
  const [items, setItems] = useState([]);

  const handleAddItem = (variantId) => {
    addItem({
      quantity: 1,
      variantId,
      isSubscription: false
    });
  };

  const buildItem = (variantId) => {
    const data = window.variantDataSelector.getData(variantId);

    if (!data) {
      return null;
    }

    const {
      productTitle,
      customTitle,
      flavor,
      variantTitle,
      image,
      price
    } = data;

    return {
      variantId,
      productTitle: customTitle || productTitle,
      customTitle,
      flavor,
      variantTitle,
      image,
      finalPrice: price
    };
  };

  useEffect(() => {
    const shouldBeHidden = checkHasSubscription(cart.items);

    if (shouldBeHidden) {
      setItems([]);
    } else {
      const filterCartItems = filterByItemId(getItemsId(cart.items));
      const filteredItems = variantIds
        .split(',')
        .map(buildItem)
        .filter(Boolean)
        .filter(filterCartItems);

      setItems(filteredItems);
    }
  }, [cart.items, variantIds]);

  return <UpsellItems items={items} isPending={isPending} onAddItem={handleAddItem} />;
};
